// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2Xzsb","selects":"Documents_selects__1tGeG"};